import React from 'react';
import { Typography, Tabs, Collapse } from 'antd';
import { ArrowLeftOutlined, MailOutlined } from '@ant-design/icons';
import { useNavigate, useSearchParams } from 'react-router-dom';
import LegalText from '../common/LegalText';
import { useLegalDocument } from '../../content/legalService';
import './InfoPage.css';

const { Title, Paragraph, Text } = Typography;

const FAQ_ITEMS = [
  {
    key: '1',
    label: 'Gdzie korzystam z MyBeautyPlace?',
    children: (
      <Paragraph>
        W darmowej aplikacji na telefon, dostępnej w App Store i Google Play. Ta strona jest tylko wizytówką:
        konto zakładasz i obsługujesz w aplikacji.
      </Paragraph>
    ),
  },
  {
    key: '2',
    label: 'Jak zarezerwować wizytę?',
    children: (
      <Paragraph>
        W aplikacji otwórz profil swojego salonu, wybierz usługę i wolny termin. Po potwierdzeniu rezerwacji
        dostaniesz powiadomienie.
      </Paragraph>
    ),
  },
  {
    key: '3',
    label: 'Jak odwołać lub zmienić termin wizyty?',
    children: (
      <Paragraph>
        W aplikacji przejdź do zakładki „Wizyty". Przy każdej zaplanowanej wizycie znajdziesz opcję odwołania
        lub zmiany terminu, zgodnie z polityką danego salonu.
      </Paragraph>
    ),
  },
  {
    key: '4',
    label: 'Czy korzystanie z aplikacji jest bezpłatne?',
    children: (
      <Paragraph>
        Tak, aplikacja MyBeautyPlace jest całkowicie bezpłatna dla klientów. Nie pobieramy żadnych opłat
        za pobranie, rezerwacje ani za konto.
      </Paragraph>
    ),
  },
  {
    key: '5',
    label: 'Jak działa program lojalnościowy?',
    children: (
      <Paragraph>
        Każdy salon może prowadzić własny program lojalnościowy. Po każdej zrealizowanej wizycie automatycznie
        naliczane są punkty, które możesz wymienić na rabaty lub darmowe usługi.
      </Paragraph>
    ),
  },
];

const TAB_KEYS = ['kontakt', 'faq', 'regulamin', 'prywatnosc'];

function InfoPage() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = TAB_KEYS.includes(searchParams.get('tab')) ? searchParams.get('tab') : 'kontakt';
  const regulamin = useLegalDocument('client-terms');
  const prywatnosc = useLegalDocument('client-privacy');

  const handleTabChange = (key) => {
    setSearchParams({ tab: key });
  };

  const items = [
    {
      key: 'kontakt',
      label: 'Kontakt',
      children: (
        <div className="info-tab-content">
          <Title level={3}>Skontaktuj się z nami</Title>
          <Paragraph>
            MyBeautyPlace to aplikacja łącząca klientów z salonami kosmetycznymi i fryzjerskimi.
            Jeśli masz pytania, sugestie lub potrzebujesz pomocy, napisz do nas.
          </Paragraph>
          <div className="info-contact-card">
            <MailOutlined className="info-contact-icon" />
            <div>
              <Text strong>Email</Text>
              <br />
              <a href="mailto:kontakt@mybeautyplace.pl">kontakt@mybeautyplace.pl</a>
            </div>
          </div>
          <Paragraph type="secondary" style={{ marginTop: 24 }}>
            Odpowiadamy na wiadomości w ciągu 24 godzin w dni robocze.
          </Paragraph>
          <Title level={5} style={{ marginTop: 32 }}>Dane firmy</Title>
          <Paragraph>Operatorem platformy MyBeautyPlace jest:</Paragraph>
          <div className="info-company-box">
            <Text strong>GRUPA POMARAŃSKI I SOBOTA Sp. z o.o.</Text>
            <div>ul. Komuny Paryskiej 58A / 52, 30-389 Kraków, Polska</div>
            <div>KRS: 0001238833</div>
            <div>NIP: 6762719106</div>
            <div>REGON: 544630139</div>
          </div>
        </div>
      ),
    },
    {
      key: 'faq',
      label: 'FAQ',
      children: (
        <div className="info-tab-content">
          <Title level={3}>Najczęściej zadawane pytania</Title>
          <Collapse
            items={FAQ_ITEMS}
            bordered={false}
            defaultActiveKey={['1']}
            className="info-faq-collapse"
          />
        </div>
      ),
    },
    {
      key: 'regulamin',
      label: 'Regulamin',
      children: (
        <div className="info-tab-content">
          <Title level={3}>Regulamin serwisu MyBeautyPlace</Title>
          <LegalText text={regulamin} />
        </div>
      ),
    },
    {
      key: 'prywatnosc',
      label: 'Prywatność',
      children: (
        <div className="info-tab-content">
          <Title level={3}>Polityka prywatności</Title>
          <LegalText text={prywatnosc} />
        </div>
      ),
    },
  ];

  return (
    <div className="info-page">
      <div className="info-page-header">
        <button className="info-page-back" onClick={() => navigate('/')}>
          <ArrowLeftOutlined />
        </button>
        <div className="info-page-header-logo" onClick={() => navigate('/')}>
          <img src="/logo-icon.png" alt="" className="info-page-logo-img" />
          <span className="info-page-logo-text">MyBeautyPlace</span>
        </div>
      </div>
      <div className="info-page-body">
        <Tabs
          activeKey={activeTab}
          onChange={handleTabChange}
          items={items}
          className="info-tabs"
        />
      </div>
    </div>
  );
}

export default InfoPage;
